import decode from 'jwt-decode'
import axios from 'axios'
import auth0 from 'auth0-js'

import {
    ACCESS_TOKEN_KEY,
    ID_TOKEN_KEY, 
    TOKEN_CUSTOM_NAMESPACE,   
    AUTH_AUDIENCE,
    AUTH_DOMAIN,
    AUTH_CLIENT_ID
} from '../utils/constants'

class AuthService {
    start() {
        this.auth = new auth0.WebAuth({
            clientID: AUTH_CLIENT_ID,
            audience: AUTH_AUDIENCE,
            domain: AUTH_DOMAIN,
            responseType: 'token id_token',
            scope: 'openid profile email'
        })
    }

    login() {
        this.auth.authorize({
            redirectUri: `${window.location.origin}/authcallback`
        })
    }

    logout() {
        this._clearIdToken()
        this._clearAccessToken()
        this.auth.logout({
            returnTo: `${window.location.origin}/login`
        })
    }
      
    refreshSession() {
        return new Promise((resolve, reject) => {
            console.log('Refreshing session')
            this.auth.checkSession({
                redirectUri: `${window.location.origin}/authcallback`
            }, (error, authResult) => {
                console.log('Refresh session came back')
                if (error) {
                    console.error('Error refreshing token', error)
                    reject(error)
                }
                else {
                    //console.log('Refresh result', authResult)
                    localStorage.setItem(ID_TOKEN_KEY, authResult.idToken)
                    localStorage.setItem(ACCESS_TOKEN_KEY, authResult.accessToken)
                    //axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
                    
                    resolve(authResult)
                }
            })
        })  
    }
      
    getIdToken() {
        return localStorage.getItem(ID_TOKEN_KEY)
    }
      
    getAccessToken() {        
        return localStorage.getItem(ACCESS_TOKEN_KEY)
    }
      
    // Get and store access_token in local storage
    setAccessToken() {
        let accessToken = this._getParameterByName('access_token')
        console.log('------------------------------')
        console.log('Access token:')
        console.log(accessToken)
        console.log('------------------------------')
        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
    }
    
    setIdToken() {
        let idToken = this._getParameterByName('id_token')
        localStorage.setItem(ID_TOKEN_KEY, idToken)
    }
      
    isLoggedIn() {
        const idToken = this.getIdToken()
        return !!idToken && !this._isTokenExpired(idToken)
    }
      
    isAccessTokenExpired() {
        const accessToken = this.getAccessToken()
        return !accessToken || this._isTokenExpired(accessToken)
    }
      
    getUserInfo() {
        if (this.isLoggedIn()) {
            return decode(this.getIdToken())
        }
    }

    getUserAttachedOrg() {
        if (this.isLoggedIn()) {
            let userInfo = this.getUserInfo()
            return  userInfo[`${TOKEN_CUSTOM_NAMESPACE}app_metadata`]          
        }
    }

    getUserProfile() {
        if (this.isLoggedIn()) {
            let userInfo = this.getUserInfo()
            let profile = {
                ...userInfo[`${TOKEN_CUSTOM_NAMESPACE}app_metadata`],
                ...userInfo[`${TOKEN_CUSTOM_NAMESPACE}profile`]
            }

            return profile

        }
    }
      
    _clearIdToken() {
        localStorage.removeItem(ID_TOKEN_KEY)
    }
      
    _clearAccessToken() {
        localStorage.removeItem(ACCESS_TOKEN_KEY)
    }
      
      // Helper function that will allow us to extract the access_token and id_token
    _getParameterByName(name) {
        let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash)
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
    }
      
    _isTokenExpired(token) {
        const expirationDate = this._getTokenExpirationDate(token)
        return expirationDate < new Date()
    }
      
    _getTokenExpirationDate(encodedToken) {
        const token = decode(encodedToken)
        if (!token.exp) { return null }
        
        const date = new Date(0)
        date.setUTCSeconds(token.exp)
        
        return date
    }
}

export default AuthService